import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Button,
  Checkbox,
  Menu,
  MenuButton,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  Badge,
  useMediaQuery,
  Text,
  Center,
  Accordion,
  AccordionItem,
  AccordionIcon,
  AccordionButton,
  Flex,
  AccordionPanel,
  Image,
  Box,
} from "@chakra-ui/react";
import { capitalize, includes, isEmpty, startCase, truncate } from "lodash";
import moment from "moment";
import { useState } from "react";
import LocationView from "../common/LocationView";
import SelectAllCheckbox from "../common/SelectAllCheckbox";
import UserUpdate from "../modals/user/update/UserUpdate";

type UsersTableContainerProps = {
  users: any[];
  refetch?: any;
  isAdmin?: boolean;
};

const UsersTableContainer = (props: UsersTableContainerProps) => {
  const { users, refetch, isAdmin } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  const [selectUpdateUser, setSelectUpdateUser] = useState<string>("");
  const [selectedCheckboxItems, setSelectedCheckboxItems] = useState<any>([]);

  const {
    isOpen: isUpdateModalOpen,
    onOpen: onOpenUpdateModal,
    onClose: onCloseUpdateModal,
  } = useDisclosure();

  return isLargerThan900 ? (
    <TableContainer my="2">
      {isEmpty(users) ? (
        <>
          <Center>
            <Text fontSize="2xl">No users found.</Text>
          </Center>
        </>
      ) : (
        <Table variant="simple" size={isLargerThan900 ? "md" : "sm"}>
          <Thead>
            <Tr>
              <Th>
                <SelectAllCheckbox
                  selectAll={() =>
                    setSelectedCheckboxItems(users.map((user: any) => user.id))
                  }
                  unSelectAll={() => setSelectedCheckboxItems([])}
                  size="lg"
                />
              </Th>

              <Th fontSize="1xl" color="black">
                {isEmpty(selectedCheckboxItems) ? (
                  "Name"
                ) : (
                  <Menu size="sm">
                    <MenuButton
                      size="sm"
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                    >
                      Actions
                    </MenuButton>
                    <MenuList>
                      {/* <MenuItem onClick={onOpenMassUpdateMpdal}>Update</MenuItem> */}
                      {/* <MenuItem onClick={onOpenRemoveUserDialog}>
                        Set as inactive
                      </MenuItem> */}
                      {/* <MenuItem>Archive</MenuItem> */}
                    </MenuList>
                  </Menu>
                )}
              </Th>
              <Th fontSize="1xl" color="black">
                Username
              </Th>

              {isAdmin && (
                <>
                  <Th fontSize="1xl" color="black">
                    Role
                  </Th>
                </>
              )}

              <Th fontSize="1xl" color="black">
                Password
              </Th>
              <Th fontSize="1xl" color="black">
                Status
              </Th>
              <Th fontSize="1xl" color="black">
                Created
              </Th>
              <Th w="1px"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {users?.map((user: any) => {
              console.log("user", user);
              return (
                <Tr
                  cursor="pointer"
                  _hover={{
                    bg: "gray.100",
                  }}
                  key={user.id}
                >
                  <Td>
                    <Checkbox
                      colorScheme="whatsapp"
                      size="lg"
                      isChecked={includes(selectedCheckboxItems, user.id)}
                      onChange={(e: any) => {
                        let updatedSelected = [...selectedCheckboxItems];
                        if (e.target.checked) {
                          updatedSelected.push(user.id);
                        } else {
                          updatedSelected = updatedSelected.filter(
                            (id) => id !== user.id
                          );
                        }
                        setSelectedCheckboxItems(updatedSelected);
                      }}
                    />
                  </Td>
                  <Td color="gray.700" display="flex" alignItems="center">
                    <Image
                      mr="3"
                      boxSize="40px"
                      src={user.imageURL}
                      rounded="sm"
                      fallbackSrc="https://via.placeholder.com/150"
                    />
                    <Box>
                      <Text fontWeight="bold">
                        {startCase(capitalize(user?.name)) || ""}
                      </Text>

                      {user?.establishment && isAdmin && (
                        <Text color="gray" fontSize="12px">
                          {truncate(startCase(user?.establishment?.name), {
                            length: 40,
                          })}
                        </Text>
                      )}
                    </Box>
                  </Td>

                  <Td fontWeight="bold" color="gray.700">
                    {user?.username || ""}
                  </Td>
                  {isAdmin && (
                    <Td>
                      <Badge
                        variant="solid"
                        colorScheme={
                          user?.role === "ADMIN"
                            ? "green"
                            : user?.role === "INDIVIDUAL"
                            ? "yellow"
                            : "orange"
                        }
                        size="md"
                        mr="3"
                      >
                        {user?.role}
                      </Badge>
                    </Td>
                  )}
                  <Td>{user.password}</Td>
                  <Td>
                    <Badge
                      variant="subtle"
                      size="lg"
                      colorScheme={
                        user.status === "active"
                          ? "green"
                          : user.status === "inactive"
                          ? "gray"
                          : user.status === "review"
                          ? "yellow"
                          : "red"
                      }
                    >
                      {user.status === "active"
                        ? "Active"
                        : user.status === "inactive"
                        ? "Inactive"
                        : user.status === "review"
                        ? "Under Review"
                        : "Removed"}
                    </Badge>
                  </Td>
                  <Td>{moment(user.createdAt).format("ll")}</Td>
                  <Td w="1px">
                    <Button
                      onClick={() => {
                        onOpenUpdateModal();
                        setSelectUpdateUser(user.id);
                      }}
                    >
                      Update
                    </Button>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      )}

      {selectUpdateUser && (
        <UserUpdate
          id={selectUpdateUser}
          isOpen={isUpdateModalOpen}
          onOpen={onOpenUpdateModal}
          onClose={onCloseUpdateModal}
          refetch={refetch}
          disabledFields={isAdmin ? [] : ["location"]}
        />
      )}
    </TableContainer>
  ) : (
    <>
      <Accordion allowToggle>
        {isEmpty(users) ? (
          <>
            <Center>
              <Text fontSize="2xl">No users found.</Text>
            </Center>
          </>
        ) : (
          <>
            {users?.map((user: any) => {
              return (
                <AccordionItem key={user.id} py="2">
                  <AccordionButton _expanded={{ bg: "gray.200" }}>
                    {/* <Checkbox
                      colorScheme="whatsapp"
                      isChecked={includes(selectedCheckboxItems, user.id)}
                      onChange={(e: any) => {
                          let updatedSelected = [...selectedCheckboxItems];
                          if (e.target.checked) {
                            updatedSelected.push(user.id);
                          } else {
                            updatedSelected = updatedSelected.filter(
                              (id) => id !== user.id
                            );
                          }
                          setSelectedCheckboxItems(updatedSelected);
                        }}
                      size="lg"
                      mr="3"
                    /> */}

                    <Flex alignItems="center" justifyContent="start" flex="2">
                      <Image
                        mr="3"
                        boxSize="40px"
                        src={user.imageURL}
                        fallbackSrc="https://via.placeholder.com/150"
                        rounded="sm"
                      />

                      <Box textAlign="start">
                        <Text
                          textAlign="left"
                          fontWeight="bold"
                          color="gray.700"
                          size="4xl"
                        >
                          {startCase(capitalize(user?.name)) || ""}
                        </Text>
                        {user?.establishment && isAdmin && (
                          <Text color="gray" fontSize="12px">
                            {truncate(startCase(user?.establishment?.name), {
                              length: 40,
                            })}
                          </Text>
                        )}
                      </Box>
                    </Flex>

                    {isAdmin && (
                      <Badge
                        variant="solid"
                        colorScheme={
                          user?.role === "ADMIN"
                            ? "green"
                            : user?.role === "INDIVIDUAL"
                            ? "yellow"
                            : "orange"
                        }
                        size="md"
                        mr="3"
                      >
                        {user?.role}
                      </Badge>
                    )}
                    <Badge
                      variant="subtle"
                      size="lg"
                      colorScheme={
                        user.status === "active"
                          ? "green"
                          : user.status === "inactive"
                          ? "gray"
                          : "red"
                      }
                      mr="3"
                    >
                      {user.status === "active"
                        ? "Active"
                        : user.status === "inactive"
                        ? "Inactive"
                        : "Removed"}
                    </Badge>

                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    <Flex
                      my="3"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text textAlign="left">Name</Text>
                      <Text fontWeight="bold">
                        {startCase(capitalize(user?.name)) || ""}
                      </Text>
                    </Flex>
                    <Flex
                      my="3"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text textAlign="left">Username</Text>
                      <Text fontWeight="bold">{user?.username || ""}</Text>
                    </Flex>

                    {isAdmin && (
                      <>
                        <Flex
                          my="3"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Text textAlign="left">Role</Text>
                          <Badge
                            variant="solid"
                            colorScheme={
                              user?.role === "ADMIN"
                                ? "green"
                                : user?.role === "INDIVIDUAL"
                                ? "yellow"
                                : "orange"
                            }
                            size="md"
                          >
                            {user?.role}
                          </Badge>
                        </Flex>
                        {user?.establishment?.name && (
                          <Flex
                            my="3"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Text textAlign="left">Establishment</Text>
                            <Text fontWeight="bold">
                              {capitalize(user?.establishment?.name || "")}
                            </Text>
                          </Flex>
                        )}
                      </>
                    )}
                    <Flex
                      my="3"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text textAlign="left">Password</Text>
                      <Text fontWeight="bold">{user.password}</Text>
                    </Flex>

                    <Flex
                      my="3"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text textAlign="left">Status</Text>
                      <Badge
                        variant="subtle"
                        size="lg"
                        colorScheme={
                          user.status === "active"
                            ? "green"
                            : user.status === "inactive"
                            ? "gray"
                            : "red"
                        }
                      >
                        {user.status === "active"
                          ? "Active"
                          : user.status === "inactive"
                          ? "Inactive"
                          : "Removed"}
                      </Badge>
                    </Flex>
                    <Flex
                      my="3"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text textAlign="left">Created</Text>
                      <Text fontWeight="bold">
                        {moment(user.createdAt).format("ll")}
                      </Text>
                    </Flex>

                    <Button
                      onClick={() => {
                        onOpenUpdateModal();
                        setSelectUpdateUser(user.id);
                      }}
                      size="sm"
                      w="full"
                    >
                      Update
                    </Button>
                  </AccordionPanel>
                </AccordionItem>
              );
            })}
          </>
        )}
      </Accordion>

      {selectUpdateUser && (
        <UserUpdate
          id={selectUpdateUser}
          isOpen={isUpdateModalOpen}
          onOpen={onOpenUpdateModal}
          onClose={onCloseUpdateModal}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default UsersTableContainer;
